import { vulnerabilitiesApi } from 'modules/cm/api';
import { CaseId } from 'modules/cm/api/cases/types';
import { FormVulnerbaility } from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant/Vulnerabilities/Vulnerability';
import { Dispatch } from 'redux';
import { addVulnerabilityFinish } from '../store/actions';

const addNewVulnerability = (
  caseId: CaseId,
  applicantId: number,
  applicantIndex: number,
  vulnerability: FormVulnerbaility,
) => {
  return async (dispatch: Dispatch) => {
    try {
      const createdVulnerability = await vulnerabilitiesApi(caseId)(applicantId).create(vulnerability);

      dispatch(addVulnerabilityFinish(applicantIndex, createdVulnerability));
    } catch (error) {
      return Promise.reject(error);
    }
  };
};

export default addNewVulnerability;
